/**
 * Colours that end up on a canvas.
 *
 * Chart.js paints into a canvas and cannot resolve CSS custom properties, so these stay literal
 * instead of going through the aliases in `theme.css`. Anything in the DOM that has to line up with
 * a chart (a legend swatch, for instance) reads from here too, so the two never drift apart.
 *
 * The series colours are the ad system's identity — Google warm, Meta cold — with a lighter tint for
 * the comparison period. They only need to stay distinguishable from each other.
 */

export const CHART_COLORS = {
  google: "#f7a12b",
  googleCompare: "#ffe764",
  meta: "#0c7fac",
  metaCompare: "#4dc8f7",
  unoptimized: "#999999",
  optimization: "#32cd32",
  optimizationMarker: "#22c55e",
};

/** Mirrors `--app-primary`, `--app-text-subtle` and `--app-text-on-accent` from `theme.css`. */
export const PIE_COLORS = {
  included: "#0eb4f3",
  excluded: "#a6a6a6",
  label: "#ffffff",
};
